<section class="main-about-fr8bot">
  <ng-content></ng-content>

  <div class="main-about-fr8bot__bg">
    <fr8bot-web-video-autoplay [src]="videoSrc()" [poster]="posterSrc()" [maskOpacity]="0.8" />
  </div>

  <div class="main-about-fr8bot__inner">
    <div class="box-border box-border--left box-border--top main-about-fr8bot-border"></div>
    <div class="box-border box-border--right box-border--top main-about-fr8bot-border"></div>
    <div class="box-border box-border--left box-border--bottom main-about-fr8bot-border"></div>
    <div class="box-border box-border--right box-border--bottom main-about-fr8bot-border"></div>

    <div class="main-about-fr8bot__inner-content">
      <div class="main-about-fr8bot__inner-content-text">
        <span class="web-section-label">
          <ng-content select="[label]"></ng-content>
        </span>

        <h2 class="main-about-fr8bot__inner-content-text-title">
          <ng-content select="[title]"></ng-content>
        </h2>

        <div class="main-about-fr8bot__inner-content-text-description">
          <ng-content select="[description]"></ng-content>
        </div>

        <div class="tw:empty:hidden">
          <ng-content select="[actions]"></ng-content>
        </div>
      </div>

      <!--      TODO: add form -->
      <!--      <div class="main-about-fr8bot__inner-content-action">-->
      <!--        <h2 class="main-about-fr8bot__inner-content-action-title">-->
      <!--          Interested in what we're building?-->
      <!--        </h2>-->

      <!--        <fr8bot-ui-button-->
      <!--          class="main-about-fr8bot__inner-content-action-button"-->
      <!--          type="primaryCut"-->
      <!--          size="large"-->
      <!--          (click)="shipNow.emit()"-->
      <!--        >-->
      <!--          Get in touch-->
      <!--          <fr8bot-ui-icon postfix-icon name="arrow-right-16" [size]="16" />-->
      <!--        </fr8bot-ui-button>-->
      <!--      </div>-->
    </div>
  </div>
</section>
